<svg [class.active]="active" fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10.6543 8.99996L17.144 2.50996C17.5663 2.08782 17.5663 1.40526 17.144 0.983115C16.7219
    0.560967 16.0393 0.560967 15.6172 0.983115L9.12732 7.47311L2.63765 0.983115C2.21532 0.560967
    1.53297 0.560967 1.11083 0.983115C0.688499 1.40526 0.688499 2.08782 1.11083 2.50996L7.6005
    8.99996L1.11083 15.49C0.688499 15.9121 0.688499 16.5947 1.11083 17.0168C1.32121 17.2274
    1.59783 17.3332 1.87424 17.3332C2.15066 17.3332 2.42708 17.2274 2.63765 17.0168L9.12732
    10.5268L15.6172 17.0168C15.8278 17.2274 16.1042 17.3332 16.3806 17.3332C16.657 17.3332
    16.9334 17.2274 17.144 17.0168C17.5663 16.5947 17.5663 15.9121 17.144 15.49L10.6543 8.99996Z"
    fill="#A6ACBE"
  />
</svg>
